import type { VisibilityMap } from "../../../../../../components/Questionnaire/validation/form/types";
import type { Answers } from "../../../../types";

type DerivePersonalisedCoverShowUpdatesArgs = {
  groupNames: string[];
  answers: Answers;
  visibility: VisibilityMap;
  serverVisibleByName: Record<string, boolean>;
};

/**
 * Pure helper: derive answers and visibility when a personalised_cover group is set to a valid non-"no" option value
 * Only values that are in the question's options array and are non-zero show child questions
 */
export const derivePersonalisedCoverShowUpdates = ({
  groupNames,
  answers,
  visibility,
  serverVisibleByName,
}: DerivePersonalisedCoverShowUpdatesArgs): {
  answers: Answers;
  visibility: VisibilityMap;
} => {
  const nextAnswers = { ...answers };
  const nextVisibility = { ...visibility };

  for (const child of groupNames) {
    nextVisibility[child] = serverVisibleByName[child] ?? false;
  }

  return { answers: nextAnswers, visibility: nextVisibility };
};
